import { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableCell,
  TableBody,
  ChipOwnProps,
  Table,
} from '@mui/material';
import React from 'react';
import { Modal } from '../../../dialogs/useModal';
import { GET_APPS } from '../../guide.graphql';
import { useQuery } from '@apollo/client';
import LoadingSpinner from '../../../LoadingSpinner';
import { Add, Cloud, VolumeUp, ElectricBolt, Extension } from '@mui/icons-material';

export interface AppsDialogResult {
  id: string;
  name: string;
}

export interface AppsDialogProps {}

export const AppsDialog: FC<Modal<AppsDialogProps, AppsDialogResult>> = (modal) => {
  const { data, loading } = useQuery(GET_APPS);

  const { close } = modal;
  const handleOnClose = () => {
    close();
  };
  const handleOnInsert = (id: string, name: string) => {
    close({ id, name });
  };
  return (
    <Dialog open={true} onClose={handleOnClose} maxWidth="lg" fullWidth={true}>
      <DialogTitle>Legg til app</DialogTitle>
      <DialogContent>
        {loading && <LoadingSpinner />}
        {data?.apps && (
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Navn</TableCell>
                  <TableCell>Kategori</TableCell>
                  <TableCell>Versjon</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.apps.map((app) => (
                  <TableRow key={app?.id}>
                    <TableCell>{app?.name}</TableCell>
                    <TableCell>
                      <CategoryChip category={app?.category ?? ''} />
                    </TableCell>
                    <TableCell>{app?.version}</TableCell>
                    <TableCell>
                      <Button
                        style={{ textWrap: 'nowrap' }}
                        variant="contained"
                        startIcon={<Add />}
                        size="small"
                        onClick={() => handleOnInsert(app?.id, app?.name ?? '')}>
                        Legg til
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose}>Avbryt</Button>
      </DialogActions>
    </Dialog>
  );
};

const getCategoryIcon = (category: string) => {
  switch (category) {
    case 'Klima':
      return <Cloud />;
    case 'Lyd':
      return <VolumeUp />;
    case 'Energi':
      return <ElectricBolt />;
    default:
      return <Extension />;
  }
};
const CategoryChip = ({ category }: { category: string }) => {
  return (
    <div>
      <Chip label={category} color="default" icon={getCategoryIcon(category)} variant="outlined" />
    </div>
  );
};
